import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';
import { getMarketOverviewBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';
import Product from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';
import finsightUrl from '@/creditflowresearch/Router/urlConstants';

const getServerSideArticleBreadcrumbs = ({ query }, headline?: string): IBreadcrumb[] => {
  const {
    products = Product.getDefaultAbbreviation(),
    regions = Region.getDefaultAbbreviation(),
  } = query;
  const commonBreadcrumbs = [
    getMarketOverviewBreadcrumbsRoute(query),
    {
      title: 'Commentary & Deal Flow',
      url: `${ finsightUrl.CREDIT_FLOW_ARTICLE_LIST_ALL }?products=${
        encodeURI(products)
      }&regions=${
        encodeURI(regions)
      }`,
    },
  ];

  if (!headline) {
    return [
      ...commonBreadcrumbs,
      {
        title: 'Post',
        isActive: true,
      },
    ];
  }

  return [
    ...commonBreadcrumbs,
    {
      title: headline,
      isActive: true,
    },
  ];
};

export default getServerSideArticleBreadcrumbs;
